<template>
    <div>
        <textarea
            v-model="model"
            v-bind="$attrs"
            class="form-control form-control-lg"
            :class="{ 'is-invalid': hasError || exceedingChars }"
            :maxlength="maxLength"
            :style="hasError ? { 'border-width': '1px' } : {}"
        />
        <p v-if="maxLength" :class="[ 'mt-1 mb-0', colorCharLeft ]"><small>Characters remaining: {{ countCharLeft }}</small></p>
    </div>
</template>

<script>
    export default {
        name: 'Textarea',
        props: {
            value: String,
            hasError: Boolean,
            maxLength: Number
        },
        computed: {
            colorCharLeft() {
                if(this.countCharLeft <= 0) return 'text-danger'
                if(this.countCharLeft < (this.maxLength / 9)) return 'text-warning'
                return 'text-muted'
            },
            countCharLeft() {
                if(!this.maxLength) return
                if(!this.model) return this.maxLength
                return this.maxLength - this.model.length
            },
            exceedingChars() {
                if(!this.model || !this.maxLength) return false
                return this.model.length > this.maxLength
            },
            model: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        }
    }
</script>
